module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [(!_vm.mobile) ? _c('Loader', {
    attrs: {
      "active": !_vm.ready
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "home-wrapper"
  }, [_c('div', {
    ref: "main",
    staticClass: "home",
    attrs: {
      "id": "main"
    }
  }, [_c('tv-header', {
    attrs: {
      "window-h": _vm.windowH
    }
  }), _vm._v(" "), _c('shows-list', {
    attrs: {
      "tours": _vm.tours,
      "shows-loaded": _vm.showsLoaded,
      "openTour": _vm.openTour
    }
  }), _vm._v(" "), _c('on-demand'), _vm._v(" "), _c('about', {
    attrs: {
      "result": _vm.result
    }
  })], 1), _vm._v(" "), _c('canvas', {
    ref: "canvasEl",
    staticClass: "animation-canvas"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-676c2594","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 287
// module chunks = 0